module.exports = __webpack_public_path__ + "static/media/avatar2.a9e2ab3e.webp";